<template>
  <div class="order-form">


	
	<!-- 核心：可编辑的 div -->
	<div  @paste="handlePaste"  contenteditable="true" style="height: 200px;  overflow-y: auto;  border: 1px solid #ddd; border-radius: 10px; padding: 10px;">
	   <!-- 在这里粘贴或输入富文本内容... -->
	</div>
	<el-button type="primary" @click="submitData" >提交</el-button>

	
	<el-form
	  ref="dynamicForm" 
	  :model="formData" 
	>
	<div
		v-for="(item, index) in formData.items" 
		:key="index" 
	>
	
	<el-row>
		<el-col :xs="24" :sm="8">
			<el-form-item
			  :label="'订单编号'"
			  :prop="`items.${index}.order_no`" 
			>
				<div class="flex">
					<el-input v-model="item.order_no"  ></el-input>	
				</div>
				
			</el-form-item>
		</el-col>
		<el-col :xs="24" :sm="8">
			<el-form-item
			  :label="'商品名称'"
			  :prop="`items.${index}.goods_name`" 
			>
				<div class="flex">
					<el-input v-model="item.goods_name"  ></el-input>			
				</div>
				
			</el-form-item>
		</el-col>
		<el-col :xs="24" :sm="8">
			<el-form-item
			  :label="'支付金额'"
			  :prop="`items.${index}.price`" 
			>
				<div class="flex">
					<el-input v-model="item.price"  ></el-input>		
				</div>
				
			</el-form-item>
		</el-col>
		<el-col :xs="24" :sm="8">
			<el-form-item
			  :label="'数量'"
			  :prop="`items.${index}.apply_quantity`" 
			>
				<div class="flex">
					<el-input v-model="item.apply_quantity" type="number"   ></el-input>	
				</div>
				
			</el-form-item>
		</el-col>
		<el-col :xs="24" :sm="8">
			<el-form-item
			  :label="'链接'"
			  :prop="`items.${index}.url`" 
			>
				<div class="flex">
					<el-input v-model="item.url" readonly ></el-input>		
				</div>
				
			</el-form-item>
		</el-col>
		
	</el-row>
	
	
	
		<el-form-item>
		  <el-button 
			type="danger" 
			icon="el-icon-delete" 
			@click="removeItem(index)"
			:disabled="formData.items.length <= 1"
		  >
			삭제
		  </el-button>
		  <el-button
			type="primary" 
			icon="el-icon-plus" 
			@click="addItem"
		  >
			상품추가
		  </el-button>
		</el-form-item>
	</div>
	</el-form>
	
	
  </div>
</template>
<script>
	export default {
	  name: "OrderPasteForm",
	  data() {
	    return {
			pasted_html:"",
			
			// 表单数据模型
			formData: {
				items: [],			 
			},
			
	    };
	  },
	  created() {
		  this.addItem()
	  },
		methods: {
			removeItem(index) {
				this.formData.items.splice(index, 1)
			},
			addItem() {
				this.formData.items.push({
					order_no: "",
					goods_name: "",
					price: "",
					apply_quantity:"",
					url:"",
				  })
			},
			submitData(){
				let doc = this.pasted_html;
				
				// 如果粘贴区域为空，则从富文本编辑器获取内容
				// if (!contentToSubmit && this.$refs.editor) {
				//   contentToSubmit = this.$refs.editor.innerHTML;
				//   console.log("从编辑器获取内容进行提交:", contentToSubmit);
				// }
				
				if (!doc) {
					alert("제출할 내용이 없습니다!");//没有可提交的内容！
					return;
				}
				
				//const sondata = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
				const sondata = doc.querySelectorAll(".trade-content-container .trade-container .trade-bought-list-order-info");
				// if(sondata.length>0){
				// 	this.formData.items.splice(0, 1)
				// }
				console.log(sondata.length,"长度")
				for(let i=0;i<sondata.length;i++){		
					this.formData.items.push({
						order_no: this.extractTbOrderNo(doc,i),
						goods_name: this.extractTbGoodsName(doc,i),
						price: this.extractTbPrice(doc,i),
						apply_quantity: this.extractTbNum(doc,i),
						url: this.extractTbUrl(doc,i),
					})
				}
				console.log(this.formData.items,"")
				this.$message.success("주문 데이터를 성공적으로 가져왔습니다!");
			},
			// 处理粘贴事件
			handlePaste(e) {
				console.log(e)
				// e.preventDefault(); // 阻止默认粘贴行为
				// 1. 获取剪贴板文本
				const clipboardData = e.clipboardData || window.clipboardData;
				const pastedText = clipboardData.getData("text/html");
				if (!pastedText) return;

				// 2. 解析HTML
				const parser = new DOMParser()
				const doc = parser.parseFromString(pastedText, 'text/html')
				  
				this.pasted_html = doc;
				console.log("成功捕获粘贴内容:", this.pasted_html);
		
			},
			// 提取订单号
			extractTbOrderNo(doc,i) {
				//const orderNo = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
				const orderNo = doc.querySelectorAll(".trade-content-container .trade-container .trade-bought-list-order-info ");
				// 遍历子级，获取每个子级的父级
				var orderid =""
				orderNo.forEach((childEl, index) => {
					const parentEl = childEl.parentElement.parentElement.previousElementSibling.querySelector('div:first-of-type span:nth-of-type(2)'); // 获取上一级父元素
					if(index == i){   
						console.log("父级元素：", parentEl.textContent.trim().replace('订单号: ', '') );
				
						orderid = parentEl.textContent.trim().replace('订单号: ', '')
					}
				});
				return orderid
			},
			// 提取商品名称
			extractTbGoodsName(doc,i) {
			  //const goodsName = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry .product-name')
			  const goodsName = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div>div>div>div>a>span:first-of-type')
			  return goodsName ? goodsName[i].textContent.trim() : ''
			},
			// 提取单价
			extractTbPrice(doc,i) {
			  //const price = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry .actual-unit-price')
			  const integer = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div>div:not(.trade-price-container-underline) .trade-price-integer')
			  
			  const decimal = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div>div:not(.trade-price-container-underline) .trade-price-decimal')
			  return integer[i].textContent+'.'+decimal[i].textContent
			},
			extractTbNum(doc,i){
				//const num = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry .quantity-amount')
				const num = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div:nth-of-type(2)>div:last-of-type')
				//console.log(num[i].textContent.trim().replace('x', '') ,"获取数量")
				return num ? num[i].textContent.trim().replace('x', '') : ''
			},
			extractTbUrl(doc,i){
				//const url = doc.querySelectorAll('.order-list-content order-item .order-item-entry-container .order-item-entry .product-name')
				const url = doc.querySelectorAll('.trade-content-container .trade-container .trade-bought-list-order-info>div>div:nth-of-type(2)>div:first-of-type>div>a')
				//console.log(url[i].getAttribute('href') ,"获取URL")
				return url ? url[i].getAttribute('href') : ''
			},
				

		}
	};
</script>
<style scoped>
	.order-form {
	  max-width: 800px;
	  margin: 20px auto;
	  padding: 20px;
	  border: 1px solid #ebeef5;
	  border-radius: 4px;
	}

	
	

	
</style>